<forge-card class="chart" no-padding>
    <forge-toolbar>
        <div slot="start" fxLayout="column">
            <h2 class="forge-typography--heading4">{{ChartTitle}}</h2>
        </div>

        <forge-icon-button slot="end" tabindex="0" (click)="openSettings()" class="chart-settings"
                           telemetry="Chart settings" aria-haspopup="true" aria-label="chart settings">
            <forge-tooltip>Chart settings</forge-tooltip>
            <forge-icon name="settings"></forge-icon>
        </forge-icon-button>
    </forge-toolbar>

    <div class="metadata-padding">
        <div *ngIf="isLoaded" class="chart-container">
            <chartjs-container *ngIf="showChart" [config]="chartConfig">
            </chartjs-container>

            <div *ngIf="!chartHasData">
                Not enough data to display graph
            </div>

            <div *ngIf="errorMessage" class="error-red">
                {{errorMessage}}
            </div>
        </div>

        <busy-indicator *ngIf="!isLoaded" [chart]="true"></busy-indicator>
    </div>
</forge-card>
